import tokenStorage from "~/services/tokenStorage";
import {ADMIN_AUTH_TOKEN} from "~/Admin/services/http/adminAxios";

const initialState = {
    isAuthenticated: !!tokenStorage.getItem(ADMIN_AUTH_TOKEN),
    user: null,
    loaded: false,
};

export default function (state = initialState, action) {

    const {payload, type} = action

    switch (type) {
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                isAuthenticated: true,
                loaded: true
            };

        case 'LOAD_USER':

            let isAuthenticated = false;

            if (payload && payload.id > 0) {
                isAuthenticated = true;
            }

            return {
                ...state,
                user: payload,
                isAuthenticated: isAuthenticated,
                loaded: true
            };

        case 'LOGOUT':
            return {
                ...state,
                isAuthenticated: false,
                user: null
            };

        default:
            return state;
    }
}
